import { Component, Input, OnInit } from '@angular/core';
import { VehicleListValue } from '../../walk-in/models/vehicle-list-value.model';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-vehicle-details-qq',
  templateUrl: './vehicle-details-qq.component.html',
  styleUrls: ['./vehicle-details.component.scss'],
})
export class QuickQuoteVehicleDetailsComponent implements OnInit {

  @Input() vrm: string;
  @Input() vehicleDescription: VehicleListValue;
  @Input() isQQDetails: boolean = true;

  salvageWarning = '';

  constructor() { }

  ngOnInit(): void {
    if (this.vehicleDescription) {
      this.salvageWarning = this.vehicleDescription.HasSalvage ? 'Salvage Auction' : '';
    }
  }

  updateQuestionFormValue(question: UntypedFormGroup) {
    question.controls.value.setValue(true);
  }

  get engineFormat() {
    return this.vehicleDescription.FuelType
      ? `${this.vehicleDescription.EngineSize}cc - ${this.vehicleDescription.FuelType}`
      : `${this.vehicleDescription.EngineSize}cc`;
  }

  get capData() {
    return this.vehicleDescription.CapCode
      ? `${this.vehicleDescription.CapCode.endsWith('L') ? 'Van' : 'Car'} - ${this.vehicleDescription.CapCodeId}`
      : `${this.vehicleDescription.CapCodeId}`;
  }
}

